import { render, staticRenderFns } from "./_base-course-review-summary.vue?vue&type=template&id=1466070f"
import script from "./_base-course-review-summary.vue?vue&type=script&lang=js"
export * from "./_base-course-review-summary.vue?vue&type=script&lang=js"
import style0 from "./_base-course-review-summary.vue?vue&type=style&index=0&id=1466070f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports